import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b7e6280"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "trailer-ready"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "277",
    height: "10",
    viewBox: "0 0 277 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M168.889 10C166.154 10 164.444 8.37607 163.932 6.15385H161.197C160.684 8.37607 158.462 10 156.239 10H150.684C148.462 10 146.496 8.63248 145.726 6.15385H143.504C142.65 8.37607 140.769 10 138.547 10C136.325 10 134.359 8.37607 133.59 6.15385H131.368C130.513 8.63248 128.632 10 126.41 10H120.855C118.632 10 116.41 8.37607 115.897 6.15385H113.162C112.65 8.37607 110.94 10 108.205 10L1.96581 5.55556C1.11111 5.55556 0 5.55556 0 4.70085C0 4.18803 1.11111 3.84615 1.96581 3.84615L108.547 0C110.769 0 112.393 1.62393 112.991 3.33333H115.726C116.239 1.7094 117.949 0 121.026 0H126.325C129.06 0 130.769 1.62393 131.282 3.33333H133.504C134.017 1.11111 136.239 0 138.462 0C140.684 0 142.906 1.11111 143.419 3.33333H145.641C146.239 1.7094 147.863 0 150.598 0H155.812C158.889 0 160.513 1.62393 161.111 3.33333H163.846C164.359 1.7094 166.068 0 168.291 0L274.872 3.84615C275.726 3.84615 276.838 4.10256 276.838 4.70085C276.838 5.55556 275.726 5.55556 274.872 5.55556L168.889 10ZM234.786 5.04273C234.786 4.18803 233.675 3.93162 232.821 3.93162L168.889 2.30769C167.265 2.30769 166.154 3.4188 166.154 5.04273H234.786ZM159.487 5.04273C159.487 3.4188 157.863 1.7094 155.897 1.7094H150.684C149.06 1.7094 147.35 3.33333 147.35 5.04273H159.487ZM141.795 5.04273C141.795 2.82051 140.171 1.7094 138.462 1.7094C136.752 1.7094 135.128 2.82051 135.128 5.04273H141.795ZM129.573 5.04273C129.573 3.4188 127.949 1.7094 125.983 1.7094H120.684C119.06 1.7094 117.35 3.33333 117.35 5.04273H129.573ZM110.769 5.04273C110.769 3.4188 109.658 2.30769 108.034 2.30769L44.1026 3.93162C43.2479 3.93162 42.1368 4.18803 42.1368 5.04273H110.769Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_3 = { class: "stripe-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "277",
    height: "10",
    viewBox: "0 0 277 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M168.889 10C166.154 10 164.444 8.37607 163.932 6.15385H161.197C160.684 8.37607 158.462 10 156.239 10H150.684C148.462 10 146.496 8.63248 145.726 6.15385H143.504C142.65 8.37607 140.769 10 138.547 10C136.325 10 134.359 8.37607 133.59 6.15385H131.368C130.513 8.63248 128.632 10 126.41 10H120.855C118.632 10 116.41 8.37607 115.897 6.15385H113.162C112.65 8.37607 110.94 10 108.205 10L1.96581 5.55556C1.11111 5.55556 0 5.55556 0 4.70085C0 4.18803 1.11111 3.84615 1.96581 3.84615L108.547 0C110.769 0 112.393 1.62393 112.991 3.33333H115.726C116.239 1.7094 117.949 0 121.026 0H126.325C129.06 0 130.769 1.62393 131.282 3.33333H133.504C134.017 1.11111 136.239 0 138.462 0C140.684 0 142.906 1.11111 143.419 3.33333H145.641C146.239 1.7094 147.863 0 150.598 0H155.812C158.889 0 160.513 1.62393 161.111 3.33333H163.846C164.359 1.7094 166.068 0 168.291 0L274.872 3.84615C275.726 3.84615 276.838 4.10256 276.838 4.70085C276.838 5.55556 275.726 5.55556 274.872 5.55556L168.889 10ZM234.786 5.04273C234.786 4.18803 233.675 3.93162 232.821 3.93162L168.889 2.30769C167.265 2.30769 166.154 3.4188 166.154 5.04273H234.786ZM159.487 5.04273C159.487 3.4188 157.863 1.7094 155.897 1.7094H150.684C149.06 1.7094 147.35 3.33333 147.35 5.04273H159.487ZM141.795 5.04273C141.795 2.82051 140.171 1.7094 138.462 1.7094C136.752 1.7094 135.128 2.82051 135.128 5.04273H141.795ZM129.573 5.04273C129.573 3.4188 127.949 1.7094 125.983 1.7094H120.684C119.06 1.7094 117.35 3.33333 117.35 5.04273H129.573ZM110.769 5.04273C110.769 3.4188 109.658 2.30769 108.034 2.30769L44.1026 3.93162C43.2479 3.93162 42.1368 4.18803 42.1368 5.04273H110.769Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "trailer-container"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "loading"
}
const _hoisted_10 = ["src"]

import { computed, nextTick, onMounted, ref } from "vue";
import { gsap } from "gsap";
import Viewport from "@/store/modules/Viewport";
import Router from "@/core/Router";
import { resolvePath } from '@/utils/Path';
import { videoStore } from "@/store/modules/Video";
import { userStore } from "@/store/modules/User";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowTrailerPage',
  setup(__props) {

const root = ref(null);
const isDownloading = ref(false);
const showTrailerReady = ref(true);
const videoURL = computed(() => videoStore.url);
// const videoURL = ref('http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4');
onMounted(() => {
  onEnter();
})

const downloadVideo = async () => {
  isDownloading.value = true;
  
  try {
    const response = await fetch(videoURL.value);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${userStore.name}-netflix-one-piece-trailer-yourself.mp4`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    isDownloading.value = false;
  } catch (error) {
    isDownloading.value = false;
    console.error(error);
  }
};

const tryAgain = () => {
  Router.push({ name: 'Home' });
}

const video = ref(null);
const isVideoFullscreen = ref(false);
const openVideo = () => {
  // isVideoFullscreen.value = true;
  // initPlayer();
}
const initPlayer = async() => {
  await nextTick();
  const player = new Plyr(video.value, {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
    fullscreen: { enabled: true, fallback: true, iosNative: true }
  });
}
const closeFullscreen = () => {
  isVideoFullscreen.value = false;
}

const onEnter = () => {
  const tl = gsap.timeline({ onComplete: () => showTrailerReady.value = false });
  const $ = gsap.utils.selector(root.value);

  tl
    .from([$('.trailer-ready svg'), $('.stripe-title')], {
      scale: 0,
      rotate: 6,
      opacity: 0,
      duration: 1,
      stagger: 0.1,
      ease: 'quart.out',
      clearProps: 'all'
    })
    .to([$('.trailer-ready svg'), $('.stripe-title')], {
      scale: 0,
      rotate: 6,
      opacity: 0,
      duration: 0.75,
      stagger: 0.1,
      ease: 'quart.inOut'
    }, 1.5)
}

return (_ctx: any,_cache: any) => {
  const _component_line_by_line = _resolveComponent("line-by-line")!
  const _component_primary_btn = _resolveComponent("primary-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: "show-trailer h-full",
    ref_key: "root",
    ref: root
  }, [
    (showTrailerReady.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h1", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (idx) => {
              return _createElementVNode("span", { key: idx }, _toDisplayString(_ctx.$t('teaser.ready')), 1)
            }), 64))
          ]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!showTrailerReady.value && !isVideoFullscreen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_line_by_line, {
                tag: "h1",
                class: "h1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('teaser.title')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: "video-container",
                onClick: openVideo
              }, [
                _createElementVNode("img", {
                  src: _unref(resolvePath)(require('@/assets/img/cadre-video.png')),
                  alt: "cadre"
                }, null, 8, _hoisted_6),
                (videoURL.value)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      src: videoURL.value + '#t=0.01',
                      controls: ""
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_primary_btn, {
                class: _normalizeClass({ 'loading': isDownloading.value }),
                onClick: downloadVideo
              }, {
                default: _withCtx(() => [
                  (!isDownloading.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: _ctx.$t('teaser.download')
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                          return _createElementVNode("span", {
                            class: "loading-item",
                            key: i
                          })
                        }), 64))
                      ]))
                ]),
                _: 1
              }, 8, ["class"]),
              _createElementVNode("button", {
                class: "link",
                onClick: tryAgain
              }, _toDisplayString(_ctx.$t('teaser.try_again')), 1)
            ]))
          : (!showTrailerReady.value && isVideoFullscreen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "video-fullscreen",
                onClick: closeFullscreen
              }, [
                (videoURL.value)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      src: videoURL.value,
                      autopla: "",
                      controls: "",
                      ref_key: "video",
                      ref: video
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})